const xlsxFileMimeType: string =
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'

export { xlsxFileMimeType }
